export default __webpack_public_path__ + "static/media/glitch002.bcb35daa.png";